export default {
  text: 'gray',
  primary: '#c8a85e',
  secondary: '#7b0101', //#7b0101
  background: '#f9f9f9',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
